import { observable } from 'mobx';
import type { ApprovalAuthorityResponseArgs } from '../approval_authority/approval_authority';
import ApprovalAuthority, {
  convertApprovalAuthorityResponseToArgs
} from '../approval_authority/approval_authority';

export type DepartmentResponseArgs = {
  id: number;
  code: string;
  name: string;
  approval_authorities?: ApprovalAuthorityResponseArgs[];
};

export type DepartmentArgs = {
  id: number;
  code: string;
  name: string;
  approvalAuthorities?: ApprovalAuthority[];
};

export const convertDepartmentResponseToArgs = (response: DepartmentResponseArgs): DepartmentArgs => {
  return {
    id: response.id,
    code: response.code,
    name: response.name,
    approvalAuthorities: response.approval_authorities?.map(
      approvalAuthority => new ApprovalAuthority(convertApprovalAuthorityResponseToArgs(approvalAuthority))
    )
  };
};

export default class Department {
  @observable id: number;
  @observable code: string;
  @observable name: string;
  @observable approvalAuthorities?: ApprovalAuthority[];

  constructor(args: DepartmentArgs) {
    this.id = args.id;
    this.code = args.code;
    this.name = args.name;
    this.approvalAuthorities = args.approvalAuthorities;
  }
}
